<template>
  <div class="parent">
    <banner v-bind:bannerObj="bannerObj"></banner>
    <div class="joinDetail">
      <p>
        一个年轻、有理想且极富创造力的创业团队，来自国内互联网金融精英和银行金融专家。<br/>
        以前所未有的创新性和共享性的产品线（国际支付、电子银行、汇率结算、贸易融资和SME购结汇、贷款等）服务国际贸易链，推动中小企业走向世界，<br/>
        共享数字贸易时代的红利。我们期待您的加入！<br/>
      </p>
    </div>
    <!--<div class="joinWrap">-->
      <!--<router-link to="/join-detail" class="applicant">-->
        <!--<div>-->
          <!--<img src="../assets/images/avatar.png" alt>-->
        <!--</div>-->
        <!--<div>-->
          <!--<span>资深产品经理</span>-->
          <!--<p>工作地点：上海市/ 招聘人数：20人</p>-->
        <!--</div>-->
      <!--</router-link>-->
      <!--<div class="applicant">-->
        <!--<div>-->
          <!--<img src="../assets/images/avatar1.png" alt>-->
        <!--</div>-->
        <!--<div>-->
          <!--<span>资深运营经理</span>-->
          <!--<p>工作地点：上海市/ 招聘人数：1人</p>-->
        <!--</div>-->
      <!--</div>-->
      <!--<div class="applicant">-->
        <!--<div>-->
          <!--<img src="../assets/images/avatar2.png" alt>-->
        <!--</div>-->
        <!--<div>-->
          <!--<span>资深UI设计师</span>-->
          <!--<p>工作地点：上海市/ 招聘人数：1人</p>-->
        <!--</div>-->
      <!--</div>-->
      <!--<div class="applicant">-->
        <!--<div>-->
          <!--<img src="../assets/images/avatar.png" alt>-->
        <!--</div>-->
        <!--<div>-->
          <!--<span>前端架构师</span>-->
          <!--<p>工作地点：上海市/ 招聘人数：1人</p>-->
        <!--</div>-->
      <!--</div>-->
      <!--<div class="applicant">-->
        <!--<div>-->
          <!--<img src="../assets/images/avatar1.png" alt>-->
        <!--</div>-->
        <!--<div>-->
          <!--<span>前端开发</span>-->
          <!--<p>工作地点：上海市/ 招聘人数：1人</p>-->
        <!--</div>-->
      <!--</div>-->
      <!--<div class="applicant">-->
        <!--<div>-->
          <!--<img src="../assets/images/avatar2.png" alt>-->
        <!--</div>-->
        <!--<div>-->
          <!--<span>android、ios开发</span>-->
          <!--<p>工作地点：上海市/ 招聘人数：1人</p>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    <footer>
      <footContent></footContent>
    </footer>
  </div>
</template>

<style lang="scss">
.parent {
  background-color: #fff;
  .joinDetail {
    width: 1200px;
    margin: 60px auto;
    p {
      text-align: center;
      font-size: 14px;
      color: #555;
      line-height: 30px;
    }
  }
  .joinWrap {
    width: 1200px;
    margin: 60px auto;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: flex-start;
    .applicant:hover {
      background: #c0baed;
    }
    .applicant {
      width: 40%;
      background: #fbfcfc;
      border-left: 10px solid #aea8db;
      padding: 30px 45px;
      margin-bottom: 30px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;
      transition: all 300ms;
      > div {
        span {
          display: block;
          color: #323232;
          font-weight: bold;
          margin-bottom: 12px;
        }
        p {
          display: block;
          color: rgba(50, 50, 50, 0.5);
        }
      }
      > div:first-child {
        margin-right: 32px;
        img {
          display: block;
          width: 60px;
          height: 60px;
        }
      }
    }
  }
}
</style>


<script>
import store from "../vuex";
import DetailBanner from "../components/DetailBanner";
import FootContent from "../components/FootContent.vue";

// import Child from '../components/Child.vue'
export default {
  data() {
    return {
      bannerObj: {
        imgUrl: require("../assets/images/join.png"),
        text: "JOIN US"
      }
    };
  },
  components: {
    banner: DetailBanner,
    footContent: FootContent
  },
  store
};
</script>

